import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { KeycloakService } from '../services/keycloak.service';

/**
 * Verlangt eine Keycloak-Session (Realm "uvi") und leitet sonst zum Login.
 * Keine Rollen-Checks: Wer sich im uvi-Realm anmelden kann und im Backend
 * als Kontakt existiert, darf das Portal nutzen.
 */
export const authGuard: CanActivateFn = async (
  _route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const keycloak = inject(KeycloakService);

  if (keycloak.isAuthenticated()) {
    return true;
  }

  await keycloak.login(window.location.origin + state.url);
  return false;
};
